module.exports = __webpack_public_path__ + "img/logo_econo_pro.b2fcf22c.png";